import AccessionsTable from "../components/accessions_table.jsx"

function Accessions() {
  return (
    <>
    <main class="flex-shrink-0">
      <div class="container">
        <h2 class="mt-5">Accessions</h2>
        <p class="lead">
          A comprehensive list of all available assemblies with link to 
          JBrowse, lat long coordinates, links to SRA, stock center, and data download page.
        </p>
        <AccessionsTable />
      </div>
    </main>
    </>
  );
}

export default Accessions;